import { makeRequest } from 'utils/requestLogger';
// import store from 'store';

export default (payload, roundtable_id) =>
  makeRequest('post', `/api/roundtables/${roundtable_id}/submit`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/submitResponse.js